import DTextField from "components/common/DTextField";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import resource from "pages/EmployeeWorkspace/Resources/compensationResource";
import DRadioGroup from "components/common/DRadioGroup";
import RHFYesNoRadio from "components/forms/RHFYesNoRadio";
import RHFToggle from "components/forms/RHFToggle";
import Box from "@mui/material/Box";
/*import RHFSelect from "components/forms/RHFSelect";*/

export default function AddEditForm({ register, errors, control }) {
    console.log({ resource });
    const renderRFLabel = (label) => {
        return <Box sx={{ minWidth: "115px" }}>{label}</Box>;
    };
    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={6}>
                <DTextField
                    // name={resource.fields.description.name}
                    label={resource.fields?.appointmentNumber?.label}
                    required={resource.fields?.appointmentNumber?.required}
                    error={!!errors?.appointmentNumber}
                    {...register(resource.fields?.appointmentNumber?.name)}
                />
            </GridItem>

            <GridItem xs={12} md={3}>
                <DTextField
                    label={resource.fields?.effectiveDate?.label}
                    required={resource?.fields?.effectiveDate?.required}
                    {...register(resource?.fields?.effectiveDate?.name)}
                    error={!!errors?.effectiveDate}
                    helperText={errors?.effectiveDate?.message}
                    type={resource?.fields?.effectiveDate?.type}
                />
            </GridItem>

            <GridItem xs={12} md={3}>
                <DTextField
                    label={resource?.fields.basicPay?.label}
                    {...register(resource?.fields?.basicPay?.name)}
                    error={!!errors?.basicPay}
                    helperText={errors?.basicPay?.message}
                />
            </GridItem>
            <GridItem>
                <GridContainer card direction="column" spacing={1}>
                    <GridItem>
                        <RHFToggle
                            name={resource?.fields?.hasSSS?.name}
                            control={control}
                            label={renderRFLabel(
                                resource?.fields?.hasSSS?.label
                            )}
                            error={!!errors?.hasSSS}
                            helperText={errors?.hasSSS?.message}
                        />
                    </GridItem>
                    <GridItem>
                        <RHFToggle
                            label={renderRFLabel(
                                resource?.fields?.hasGsis?.label
                            )}
                            control={control}
                            {...register(resource?.fields?.hasGsis?.name)}
                            error={!!errors?.hasGsis}
                            helperText={errors?.hasGsis?.message}
                        />
                    </GridItem>
                    <GridItem>
                        <RHFToggle
                            label={renderRFLabel(
                                resource?.fields?.hasPagIbig?.label
                            )}
                            control={control}
                            {...register(resource?.fields?.hasPagIbig?.name)}
                            error={!!errors?.hasPagIbig}
                            helperText={errors?.hasPagIbig?.message}
                        />
                    </GridItem>
                    <GridItem>
                        <RHFToggle
                            label={renderRFLabel(
                                resource?.fields?.hasPhilHealth?.label
                            )}
                            control={control}
                            {...register(resource?.fields?.hasPhilHealth?.name)}
                            error={!!errors?.hasPhilHealth}
                            helperText={errors?.hasPhilHealth?.message}
                        />
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
}
